import React from "react";
import Checkbox from "material-ui/Checkbox";
import CheckboxNew from "@techsoftware/happay-widgets/Checkbox";

export default class CustomCheckbox extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { checked, fromFilter, iconSize, paperViewSelectType } = this.props;
        const isRadioBtn = paperViewSelectType === "radiobutton";
        const paperViewIconStyle = isRadioBtn
            ? {
                  height: 20,
                  width: 20,
                  marginRight: 8
              }
            : {};
        const paperViewLblStyle = isRadioBtn
            ? {
                  color: "rgba(0, 0, 0, 0.87)",
                  fontWeight: 400,
                  fontSize: 12,
                  margin: 0,
                  padding: "2px 8px 0px"
              }
            : {};
        if ((this.props.isWidgetComp || fromFilter) && !isRadioBtn)
            return (
                <CheckboxNew
                    {...this.props}
                    value={checked || this.props.value || false}
                    onClick={this.props.onClick || this.props.onCheck}
                    size={fromFilter ? "small" : iconSize}
                    labelstyle={{ borderRadius: 3 }}
                />
            );
        return (
            <Checkbox
                {...this.props}
                iconStyle={Object.assign(
                    {},
                    { fill: checked ? "#1D7CBF" : "#3c424e", height: 20, width: 20 },
                    this.props.iconStyle,
                    paperViewIconStyle
                )}
                labelStyle={Object.assign(
                    {
                        fontSize: "12px",
                        color: "#203454",
                        height: "16px",
                        fontWeight: "400",
                        lineHeight: "20px"
                    },
                    this.props.labelStyle,
                    paperViewLblStyle
                )}
                style={isRadioBtn ? { marginLeft: 1, padding: 6 } : {}}
            ></Checkbox>
        );
    }
}
